import React from 'react';
import { Box, Flex, TextV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';

type MatchTierDividerProps = Readonly<{
  /** No design matched every filter, so everything below is a partial match. */
  noExactMatches?: boolean;
}>;

/**
 * Marks where the designs matching every selected filter end and the ones matching only some
 * of them begin (Amy, 2026-10-10: AND at the top, "fill in with OR" below). Spans the whole
 * gallery row so the seam is unmistakable; without it the fill reads as a broken filter.
 */
export const MatchTierDivider = ({ noExactMatches = false }: MatchTierDividerProps) => {
  const { tq } = useTranslation('stationery');
  const label = noExactMatches ? tq`No designs match all of your filters — these match some of them` : tq`More designs that match some of your filters`;
  return (
    <Flex
      role="separator"
      // A separator's children are presentational, so the line has to carry its own name or
      // screen readers get an unlabelled divider where the sighted reader gets the explanation.
      aria-label={label}
      gridColumn="1 / -1"
      alignItems="center"
      columnGap={4}
      paddingY={4}
      data-testid="match-tier-divider"
    >
      <Box
        flex={1}
        height="1px"
        backgroundColor="mono4"
      />
      <TextV2
        typographyVariant="label2"
        color="mono12"
        textAlign="center"
      >
        {label}
      </TextV2>
      <Box
        flex={1}
        height="1px"
        backgroundColor="mono4"
      />
    </Flex>
  );
};
